var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"podcast-nav"},[_c('ul',{staticClass:"podcast-nav-list"},[_vm._l((_vm.sections),function(section){return _c('li',{key:section.slug,staticClass:"podcast-nav-item"},[_c('router-link',{staticClass:"podcast-nav-link",attrs:{"to":{
          name: 'PodcastsSection',
          params: {
            id: _vm.podcastId,
            section: section.slug,
            tenant: _vm.$route.params.tenant,
          },
        }}},[_vm._v(" "+_vm._s(section.label)+" ")])],1)}),_c('li',{staticClass:"podcast-nav-filler"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }